<template>
  <!-- <hooper :progress="true" :autoPlay="true" :playSpeed="2000"> -->
  <div>
    <hooper style="height: 400px" :autoPlay="true">
      <slide>
        <img src="../../../../static/img/page1.jpg" style="width:100%; height: 400px;">
      </slide>
      <slide>
        <img src="../../../../static/img/page2.jpg" style="width:100%; height: 400px;">
      </slide>
      <slide>
        <img src="../../../../static/img/page3.jpg" style="width:100%; height: 400px;">
      </slide>
      <slide>
        <img src="../../../../static/img/page4.jpg" style="width:100%; height: 400px;">
      </slide>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
    <form action="#" target="_blank">
      <p class="w3-center">
        <router-link :to="{path:'/a/reg'}" class="w3-button w3-orange w3-section">SUBSCRIBE MILK</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import {Hooper, Slide, Pagination as HooperPagination} from 'hooper'
import '../../../../node_modules/hooper/dist/hooper.css'
export default {
  name: 'App',
  components: {
    Hooper,
    Slide,
    HooperPagination
  },
  created () {
    var fullUrl = document.URL
    var splitUrl = fullUrl.split('r1?')
    sessionStorage.setItem('urlstr', splitUrl[1])
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/R1.vue